/**
 * Starting a crosstab from a DANI chat (M4S-5777 X149–X151, decision L1).
 *
 * One flag, read on the client (the card, the Build a crosstab button) and on the server (the
 * primer and plan routes, through `requireCrosstabDani({ launch: true })`). It fails to off: a
 * flag that cannot be read is off. While `DANI_LAUNCH_INTERNAL_ONLY` is true the launch is also
 * staff-only whatever the flag says, so a mis-set override cannot reach a client during the alpha.
 * DANI access is required as well, as for every DANI flow in a crosstab.
 *
 * Spec: docs/pdlc/crosstabs-dani.md.
 */

export const CROSSTABS_DANI_LAUNCH_FLAG = 'crosstabs-dani-launch';

/** The alpha is internal (decision L1). Turning this off is a deliberate, reviewed change. */
export const DANI_LAUNCH_INTERNAL_ONLY = true;

/** Pure: whether this person may start a crosstab from a DANI chat. */
export function mayLaunchCrosstabFromDani(input: {
    flagOn: boolean;
    isInternal: boolean;
    hasDaniAccess: boolean;
}): boolean {
    if (!input.flagOn || !input.hasDaniAccess) return false;
    return DANI_LAUNCH_INTERNAL_ONLY ? input.isInternal : true;
}
